/*
 * @Author: 丨小小风离丨
 * @Date: 2023-12-04 19:47:24
 * @LastEditTime: 2024-04-22 19:59:14
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\store\index.ts
 * @Description: 
 */
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from 'redux-persist';
import storage from "redux-persist/es/storage";

import baseInfo from "./reducers/baseInfo";
import schoolInfo from "./reducers/schoolInfo";
import userInfo from "./reducers/userInfo";

const userInfoPersistConfig = {
  key: 'userInfo',
  storage,
}
const persistedUserInfoReducer = persistReducer(userInfoPersistConfig, userInfo);

const store = configureStore({
  reducer: {
    baseInfo,
    userInfo: persistedUserInfoReducer,
    schoolInfo
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const persistor = persistStore(store)
export default store;
